import { reactive, computed } from "vue";
import { defineStore } from "pinia";
import api from "@/services/network-service.js";

export const clientStore = defineStore("client", () => {
  const state = reactive({
    properties: {},
    capabilities: [],
  });

  const properties = computed(() => state?.properties);
  const capabilities = computed(() => state?.capabilities);

  const getProperties = () => {
    return new Promise((resolve, reject) => {
      api
        .post("/execute", {
          method: "GET",
          function: `/client`,
        })
        .then(({ data }) => {
          state.properties = data;
          if (data.hasOwnProperty("capabilities")) {
            state.capabilities = data["capabilities"]
              .split(",")
              .map((p) => p.trim());
          }
          resolve(state.properties);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  return {
    properties,
    capabilities,
    getProperties,
  };
});
